module.exports = "#captcha-image {\r\n    margin-bottom: 20px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reset-password/reset-password.component.css
// module id = ./src/app/components/reset-password/reset-password.component.css
// module chunks = main